import React, { useCallback, useState } from 'react';
import { Button } from '@mui/material';
import Modal from 'components/shared/Modal';
import { useSnackbar } from 'notistack';
import { ModalProps } from 'store/types/ComponentProps';
import { Claim } from 'store/types/Claim';
import { defaultSnackbarErrorProps } from 'util/Layout';

import commonStyles from 'styles/common.module.scss';
import ApplicationsService from 'services/api/ApplicationsService';
import ClaimType from 'store/enums/ClaimType';

interface DeleteDraftApplicationModalProps extends ModalProps {
  data?: Claim;
  onSubmit: () => void;
}

const DeleteDraftApplicationModal: React.FunctionComponent<DeleteDraftApplicationModalProps> = ({
  data,
  open,
  onClose,
  onSubmit,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(() => {
    if (data) {
      setLoading(true);
      ApplicationsService.deleteApplication(
        data.type === ClaimType.Dispute ? data.disputeApplicationId : data.claimApplicationId
      )
        .then(() => {
          onSubmit();
          enqueueSnackbar('Application successfully deleted', { variant: 'success' });
        })
        .catch((errorMessage: string) => {
          enqueueSnackbar(errorMessage, defaultSnackbarErrorProps);
        })
        .finally(() => setLoading(false));
    }
  }, [data, enqueueSnackbar, onSubmit]);

  return (
    <Modal
      title={'Delete Draft Application'}
      open={open}
      maxWidth={'xs'}
      loading={loading}
      onSubmit={handleSubmit}
      actions={
        <>
          <Button color={'secondary'} variant={'outlined'} onClick={onClose} disabled={loading}>
            {'Cancel'}
          </Button>
          <Button
            type={'submit'}
            disabled={loading}
            variant={'contained'}
            className={commonStyles.dangerButtonContained}
          >
            {'Delete'}
          </Button>
        </>
      }
    >
      <p className={commonStyles.text}>{'The draft application will be deleted permanently'}</p>
    </Modal>
  );
};
export default DeleteDraftApplicationModal;
